import script from "./TableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./TableActions.vue?vue&type=script&setup=true&lang=js"

import "./TableActions.vue?vue&type=style&index=0&id=7ffd153c&scoped=true&lang=scss"
script.__scopeId = "data-v-7ffd153c"

export default script